import { Grid2, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import { useTranslate } from "../../../hooks/useTranslate";
import Breadcrumbs from "../../../components/Breadcrumbs";
import { useStudents } from "../../../context/students";
import TaskCard from "../../../components/TaskCard";
import Students1 from "../../../assets/images/images/academic-students.jpg";
import Students2 from "../../../assets/images/images/academic-students-2.png";
import useStatuses from "../../../context/status/useStatuses";
import { ISAMS_LINK } from "../../../services/isamsConfig";
import { hasPermission, PERMISSIONS } from "../../../constants/permissions";

const Academic = () => {
    const { t } = useTranslate();

    const { activeStudentId, permissions } = useStudents();
    const { studentIsamsId } = useStatuses();

    const showHistoricalAbsences = hasPermission(permissions, PERMISSIONS.ATTENDANCE_MANAGE);

    return (
        <div className="page-content">
            <div className="student-head-section" />
            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, md: 7, lg: 8 }}>
                    <Breadcrumbs
                        breadcrumbs={[
                            { label: t("navigation.home"), href: `/home/${activeStudentId}` },
                            { label: t("academic.title"), current: true },
                        ]}
                    />
                    <Typography variant="h1" className="text-white">
                        {t("academic.title")}
                    </Typography>
                    <Typography variant="body1" className="mt-4 text-white" component="div">
                        {t("academic.subtitle")}
                    </Typography>
                    <Typography variant="h1" component="h2" className="mt-8 text-white">
                        {t("common.quickLinks")}
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 5, lg: 4 }}>
                    <div className="images-head-section">
                        <div className="img-head-section">
                            <img alt="students-1" src={Students1} />
                        </div>
                        <div className="img-head-section">
                            <img alt="students-2" src={Students2} />
                        </div>
                    </div>
                </Grid2>
            </Grid2>
            <Grid2 container spacing={4} className="mt-4">
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <TaskCard title={t("academic.schoolReports")}>
                        <Typography variant="body1" components="div">
                            {t("academic.schoolReportsText")}
                        </Typography>
                        <Button
                            href={`https://${ISAMS_LINK}/#/school-profile/school-reports`}
                            target="_blank"
                            className="w-full mt-4 text-base button-primary"
                        >
                            {t("button.viewNow")}
                        </Button>
                    </TaskCard>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <TaskCard title={t("academic.rewardsConcerns")}>
                        <Typography variant="body1" component="div">
                            {t("academic.rewardsConcernsText")}
                        </Typography>
                        <Button
                            href={`https://${ISAMS_LINK}/#/school-profile/reward-conduct`}
                            target="_blank"
                            className="w-full mt-4 text-base button-primary"
                        >
                            {t("button.viewNow")}
                        </Button>
                    </TaskCard>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <TaskCard title={t("academic.gradeBooks")}>
                        <Typography variant="body1" component="div">
                            {t("academic.gradeBooksText")}
                        </Typography>
                        <Button
                            href={`https://${ISAMS_LINK}/#/school-profile/gradebooks`}
                            target="_blank"
                            className="w-full mt-4 text-base button-primary"
                        >
                            {t("button.viewNow")}
                        </Button>
                    </TaskCard>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <TaskCard title={t("academic.absenceRequests")}>
                        <Typography variant="body1" component="div">
                            {t("academic.absenceRequestsText")}
                        </Typography>
                        <Button
                            href={`https://${ISAMS_LINK}/#/communication/leave-requests`}
                            target="_blank"
                            className="w-full mt-4 text-base button-primary"
                        >
                            {t("button.viewNow")}
                        </Button>
                    </TaskCard>
                </Grid2>
                {showHistoricalAbsences ? (
                    <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                        <TaskCard title={t("academic.historicalAbsences")}>
                            <Typography variant="body1" components="div">
                                {t("academic.historicalAbsencesText")}
                            </Typography>
                            <Button
                                to={`/academic/historical-absences/${activeStudentId}`}
                                component={Link}
                                className="w-full mt-4 text-base button-primary"
                            >
                                {t("button.viewNow")}
                            </Button>
                        </TaskCard>
                    </Grid2>
                ) : null}
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <TaskCard title={t("academic.attendanceSummary")}>
                        <Typography variant="body1" component="div">
                            {t("academic.attendanceSummaryText")}
                        </Typography>
                        <Button
                            href={`https://${ISAMS_LINK}/#/school-profile/attendance`}
                            target="_blank"
                            className="w-full mt-4 text-base button-primary"
                        >
                            {t("button.viewNow")}
                        </Button>
                    </TaskCard>
                </Grid2>
            </Grid2>
        </div>
    );
};

export default Academic;
